// 添加原料
<template>
  <a-modal
    :visible="visible.batchNutrition"
    @ok="ok"
    :bodyStyle="{ padding: '10px' }"
    :destroyOnClose="true"
    :forceRender="true"
    @cancel="toggleVisible('batchNutrition')"
    width="1000px">
    <span class="title" slot="title">修改营养指标限制条件 <b>在选中的配方中对于相同营养指标的限制条件进行统一编辑</b></span>
    <div class="raw-model-info-row">
      可修改指标明细：
      <span>{{ formulaSelectedRows.map((item) => `【${item.formulaName}】`).join(',') }}</span>
    </div>
    <div class="raw-model-info-row">修改原料明细：</div>
    <a-spin :spinning="addLoading">
      <a-space style="padding: 0 0 10px">
        <a-button @click="toggleVisible('batchAddNutList')" type="primary">添加</a-button>
      </a-space>
      <a-table
        bordered
        :columns="columns"
        :scroll="{ x: 970, y: 450 }"
        :row-selection="{ selectedRowKeys, onChange: onSelectChange }"
        :loading="nutLoading"
        :data-source="list"
        :row-key="(record) => record.id"
        :pagination="false">
        <template :slot="col" slot-scope="text, record" v-for="col in ['maxValue', 'minValue']">
          <cell-editor :key="col" :len="len(record)" :item="record" :name="col" @blur="(target) => itemUpdate(target, record.id)" :text="text" />
        </template>
        <template slot="option" slot-scope="record, val, index">
          <a @click="deleteItem(index)">删除</a>
        </template>
      </a-table>
    </a-spin>
    <nutrition-batch-add-modal @ok="addOk" :relist="list" />
  </a-modal>
</template>
<script>
import { formulaMixins } from '../unitls';
import NutritionBatchAddModal from './NutritionBatchAddModal.vue';
import CellEditor from '../editor/CellEditor.vue';

export default {
  components: { NutritionBatchAddModal, CellEditor },
  mixins: [formulaMixins],
  data() {
    return {
      nutLoading: false,
      filterData: {},
      list: [],
      addLoading: false,
      columns: [
        {
          dataIndex: 'name',
          title: '指标名称',
          ellipsis: true,
        },
        {
          dataIndex: 'fullName',
          title: '全称',
          ellipsis: true,
        },
        {
          dataIndex: 'formulaName',
          title: '配方名称',
          ellipsis: true,
          width: 100,
        },
        {
          dataIndex: 'formulaCode',
          title: '配方代码',
          ellipsis: true,
          width: 100,
        },
        {
          dataIndex: 'unit',
          title: '单位',
          ellipsis: true,
          width: 50,
          align: 'center',
        },
        {
          dataIndex: 'minValue',
          title: '最小值',
          align: 'center',
          scopedSlots: { customRender: 'minValue' },
          width: 100,
        },
        {
          dataIndex: 'maxValue',
          scopedSlots: { customRender: 'maxValue' },
          align: 'center',
          title: '最大值',
          width: 100,
        },
        {
          title: '操作',
          align: 'center',
          width: 90,
          scopedSlots: { customRender: 'option' },
        },
      ],
    };
  },

  watch: {
    'visible.batchNutrition'() {
      this.restList();
    },
  },

  methods: {
    len(item) {
      return item.unit === 'MJ' || item.unit === 'Kcal' ? 0 : 3;
    },

    deleteItem(index) {
      let list = [...this.list];
      list.splice(index, 1);
      this.list = list;
    },

    itemUpdate(item) {
      const list = [...this.list];
      const targets = list.filter((i) => i.id === item.id)[0];
      if (targets) {
        this.list = list;
        Object.assign(targets, item);
        this.list = list;
      }
    },
    addOk(val) {
      this.list = [...val, ...this.list];
    },

    inputChange({ target }) {
      this.getList({
        name: target.value,
      });
    },

    async batchAddNutriton() {
      return this.fetchPost({
        actions: this.batchUpdateFormulaNutritionLimitCond,
        loading: 'addLoading',
        data: {
          formulaTaskFormulaNutritionVOList: this.list,
        },
      });
    },

    async ok() {
      if (this.list.length > 0) {
        await this.batchAddNutriton();
        this.toggleVisible('batchNutrition');
        this.$emit('ok');
        this.$emit('refresh');
      } else {
        this.$message.warn('请添加的营养指标');
      }
    },

    restList() {
      this.filterData = {};
      this.rawType = [];
      this.list = [];
      this.cleanSelect();
    },

    onSearch(name) {
      this.getList({
        name,
      });
    },

    typeChange(val) {
      this.rawType = val;
      const typeId = [...val].pop();
      this.filterData.typeId = typeId;
      this.getList({
        typeId,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;

  b {
    font-size: 12px;
    font-weight: normal;
    color: #999;
    margin-left: 10px;
  }
}

.raw-model-info-row {
  margin-bottom: 8px;

  span {
    color: #999;
  }
}
</style>
